import React from "react"
import classnames from "classnames"
import styles from "./BookServiceForm.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import urlHandler from "AtomicUtils/urlHandler"
import { WINDOW } from "constants/environment"
import {
  InputText,
  Space,
  InputCheckBox,
  A,
  Button,
  InputSelect,
  H3,
  H5,
  Content,
  Section,
  FormGroup,
  InputEmail,
  P
} from "AtomicComponents"
import { AlertList, DealerSearch, InputDate } from "AtomicContainers"
import ServiceSummary from "./ServiceSummary"
import InputSearchable from "../InputSearchable/InputSearchable"
import fetchAPI from "AtomicUtils/fetchAPI"
import { formSetDefaultValues, fromLinkInputs, formLinkSubmit } from "AtomicUtils/formHandler"
import dateHandler from 'AtomicUtils/dateHandler'
import componentParser from "AtomicUtils/componentParser"
import MESSAGES from "AtomicConstants/MESSAGES"
import TITLES from "./TITLES"
import TIMES from "./TIMES"
import { DealerSearchBoxNZ } from "components"

class BookServiceForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        model: {
          validations: {
            required: MESSAGES.MODEL_FREETEXT_REQUIRED
          }
        },
        vinRego: {
          validations: {
          }
        },
        odometer: {
          validations: {
            odometer: MESSAGES.ODOMETER_INVALID
          }
        },
        title: {
          validations: {
            required: MESSAGES.TITLE_REQUIRED
          }
        },
        region: {
          validations: {
          }
        },
        dealer: {
          validations: {
            required: MESSAGES.DEALERS_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: MESSAGES.LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: MESSAGES.PHONE_NUMBER_REQUIRED,
            phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        comments: {
          validations: {
          }
        },
        date: {
          validations: {
            required: MESSAGES.DATE_REQUIRED,
          }
        },
        dropOff: {
          validations: {
            required: MESSAGES.TIME_REQUIRED,
          }
        },
        pickUp: {
          validations: {
            required: MESSAGES.TIME_REQUIRED,
          }
        },
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        privacy: {
          validations: {
            required: MESSAGES.PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null,
    }
  }

  componentDidMount() {
    const { vinRego, vehicle, models, initialLocations } = this.props
    const currentURL = new urlHandler(WINDOW.location.href)

    if (vinRego) {
      formSetDefaultValues(this, { vinRego })
    }

    if (vehicle) {
      if (vehicle.nameplate) {
        formSetDefaultValues(this, { model: vehicle.nameplate })
      }
      if (vehicle.vin) {
        formSetDefaultValues(this, { vinRego: vehicle.vin })
      }
    }

    formSetDefaultValues(this, { dropOff: "09:00 AM" })
    formSetDefaultValues(this, { pickUp: "12:00 PM" })

    // Handling pre-selecting models
    const queryModel = this.props.model || currentURL.query.model
    if (queryModel) {
      const model = models.find(item => item.name.split(/[^a-zA-Z0-9]+/).join('-').toLowerCase() === queryModel)

      if (model && model.value) {
        formSetDefaultValues(this, {
          model: String(model.value)
        })
      }
    }

    if (initialLocations && initialLocations[0] && initialLocations[0].postCode) {
      formSetDefaultValues(this, {
        region: initialLocations[0].postCode
      })
    }

    const { serviceCode, asmc, isChangeItemsEnabled } = currentURL.query
    this.setState({
      serviceCode,
      asmc: Array.isArray(asmc) ? asmc : [asmc], // Store asmc as an array even if there's 1 element for easier data conversion,
      isChangeItemsEnabled
    })
  }

  serviceType = () => {
    const { serviceOptions } = this.props

    try {
      // trying to guess MSS vs SPG service type
      // MSS factoryCode starts with 'S' and SPG starts with 'M' (yes, it's counterintuitive)
      if (serviceOptions && serviceOptions.serviceItems[0].basePrice === 0) {
        return 'COMP'
      } else if (
        serviceOptions &&
        serviceOptions.serviceItems.some(si => si.factoryCodeEntity.code[0] === 'M')
      ) {
        return 'SPG'
      }
      return 'MSS'
    } catch (e) {
      if (process.env.NODE_ENV === 'development') console.log(e)
      return false
    }
  }

  _handleSubmit = async (event) => {
    const { buttonText = "Request a service" } = this.props
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { submitServiceFormEndPoint, vehicleNotesForDealer, serviceOptions } = this.props
        const { form, asmc, serviceCode } = this.state

        const asmcDescriptions = []
        serviceOptions &&
          serviceOptions.serviceItems.forEach((item, index) => {
            asmc.forEach((addtionalItemCode) => {
              if (item.factoryCode === addtionalItemCode) {
                asmcDescriptions.push(item)
              }
            })
          })
        const baseDescription =
          serviceCode &&
          serviceOptions &&
          serviceOptions.serviceItems.find(({ factoryCode }) => factoryCode === serviceCode)

        let body = {
          nameplate: form.model.value,
          vinRego: form.vinRego.value,
          odometer: form.odometer.value || "0",
          email: form.email.value,
          comments: form.comments.value,
          firstName: form.firstName.value,
          lastName: form.lastName.value,
          phone: form.phone.value,
          title: form.title.value,
          dealerLocation: form.dealer.value.id,
          dealerCode: form.dealer.value.dealerCode,
          postCode: form.dealer.value.postCode,
          suburb: form.dealer.value.suburb,
          state: form.dealer.value.state,
          preferredDate: form.date.value && new dateHandler(form.date.value).format('0D/0M/YYYY') || '',
          preferredDropOffTime: form.dropOff.value,
          preferredPickUpTime: form.pickUp.value,
          modelCode: serviceOptions && serviceOptions.modelCode,
          serviceSpecCode: serviceOptions && serviceOptions.serviceSpecCode,
          vehicleNotesForDealer,
          serviceOptions: baseDescription ? [baseDescription, ...asmcDescriptions] : null
        }

        await fetchAPI({
          method: "POST",
          url: submitServiceFormEndPoint,
          body: body
        })
        .then(async (response) => {
          const json = await response.json()
          const { success, errorMsg } = json
          if (!success) {
            this.setState({
              errorMessage: errorMsg,
              loading: false
            })
          } else {
            // successful
            this.setState({
              loading: false,
              success: true
            }, () => {
              gtmHandler({
                pageCategory: "Request A Service Form",
                pageAction: `Request A Service Form - Clicked "${buttonText.toUpperCase()}"`
              })
            })
          }
        })
        .catch((response) => {
          this.setState({
            errorMessage: response.message || `Failed with status ${response.status}`,
            loading: false
          })
        })
      })
    }
  }

  _handleOnBlurSearchableRegion = (value) => {
    if (value && value.display) {
      gtmHandler({
        pageCategory: "Request A Service Form",
        pageAction: `Request A Service Form - Selected "DEALER" - "${value.display.toUpperCase()}"`
      })
    }

    if (value && value.description) {
      gtmHandler({
        pageCategory: "Request A Service Form",
        pageAction: `Request A Service Form - Selected "POSTCODE/SUBURB" - "${value.description.toUpperCase()}"`
      })
    }
  }

  selectDealer = (dealer) => {
    // no search, use the selected dealer only for the radio inputs
    // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
    this.refs.dealerSearchComp.setState({
      dealers: [dealer],
      selected: dealer,
      loading: false
    })
  }

  render() {
    const {
      title,
      introText,
      privacyPolicy,
      privacyPolicyLink,
      buttonText = "Request A Service",
      serviceOptions,
      serviceSummaryDescription,
      vinRego,
      initialLocations = [],
      thankYouComponents,
      dealersEndPoint = "/api/dealer-search",
      dealerSearchEndPoint
    } = this.props
    const { loading, form, success, errorMessage, serviceCode, asmc, isChangeItemsEnabled } = this.state

    if (success) {
      return componentParser(thankYouComponents)
    }

    return (
      <Section padding>
        <div className={classnames({
          [styles.BookServiceForm]: true
        })}>
          <H3 withDetails>{title}</H3>
          <Content xmlString={introText} />
          <div className={classnames({
            [styles.BookServiceFormForm]: true
          })}>
            <form method="POST" onSubmit={this._handleSubmit} noValidate>
              <FormGroup center>
                <H5>
                  About Your Mazda
                </H5>
              </FormGroup>

              <FormGroup>
                <InputText
                  name="model"
                  label="Model"
                  {...fromLinkInputs(this, "model")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: `Request A Service Form - Entered "${form.model.value}"`
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="vinRego"
                  label="Registration/VIN"
                  {...fromLinkInputs(this, "vinRego")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: `Request A Service Form - Entered "VINREGO"`
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="odometer"
                  label="Odometer"
                  {...fromLinkInputs(this, "odometer")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: `Request A Service Form - Entered "${form.odometer.value}"`
                    })
                  }}
                />
              </FormGroup>

              <FormGroup center>
                <H5>
                  About You
                </H5>
              </FormGroup>

              <FormGroup>
                <InputSelect
                  name="title"
                  label="Title"
                  options={TITLES}
                  {...fromLinkInputs(this, "title")}
                  onBlur={()=>{
                    if (form.title.value) {
                      gtmHandler({
                        pageCategory: "Request A Service Form",
                        pageAction: `Request A Service Form - Selected "TITLE" - "${form.title.value.toUpperCase()}"`
                      })
                    }
                  }}
                />
              </FormGroup>

              <FormGroup>
                <InputText
                  name="firstName"
                  label="First Name"
                  {...fromLinkInputs(this, "firstName")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: "Request A Service Form - Entered \"FIRSTNAME\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="lastName"
                  label="Last Name"
                  {...fromLinkInputs(this, "lastName")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: "Request A Service Form - Entered \"LASTNAME\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="phone"
                  label="Phone"
                  {...fromLinkInputs(this, "phone")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: "Request A Service Form - Entered \"PHONE\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputEmail
                  name="email"
                  label="Email"
                  {...fromLinkInputs(this, "email")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: "Request A Service Form - Entered \"EMAIL\""
                    })
                  }}
                />
              </FormGroup>

              {/* <FormGroup>
                <InputSearchable
                  name="region"
                  type="dealer"
                  dealersEndPoint={dealersEndPoint}
                  label="Enter your postcode, suburb or Dealer name"
                  {...fromLinkInputs(this, "region")}
                  onBlur={this._handleOnBlurSearchableRegion}
                />
              </FormGroup> */}

              <H5 textAlign="center">Find a dealer</H5>
              <P>Select your region and we'll give you a list of your local Mazda Dealerships.</P>

              <DealerSearchBoxNZ
                searchType="SERVICE"
                noMap={true}
                selectDealerVariant={true}
                selectDealer={this.selectDealer}
              />
              <FormGroup>
                <DealerSearch
                  dealersEndPoint={dealersEndPoint}
                  endpoint={dealerSearchEndPoint}
                  disabled={!form.region.value || !(form.region.value.postcode || form.region.value.value)}
                  type="Service"
                  name="dealer"
                  postcode={form.region.value && form.region.value.postcode || (initialLocations && initialLocations[0] && initialLocations[0].postCode)}
                  dealerCode={form.region.value && form.region.value.value}
                  ref="dealerSearchComp"
                  {...fromLinkInputs(this, "dealer")} />
              </FormGroup>

              <FormGroup center>
                <H5>
                  Your Service Requirements
                </H5>
              </FormGroup>

              <FormGroup>
                <InputDate
                  name="date"
                  label="Preferred Date"
                  {...fromLinkInputs(this, "date")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: "Request A Service Form - Entered \"DATE\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputSelect
                  name="dropOff"
                  label="Preferred Drop Off Time"
                  options={TIMES}
                  {...fromLinkInputs(this, "dropOff")}
                  onBlur={() => {
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: `Request A Service Form - Selected "DROP OFF TIME" - "${form.dropOff.value}"`
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputSelect
                  name="pickUp"
                  label="Preferred Pick Up Time"
                  options={TIMES}
                  {...fromLinkInputs(this, "pickUp")}
                  onBlur={() => {
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: `Request A Service Form - Selected "DROP OFF TIME" - "${form.pickUp.value}"`
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="comments"
                  label="Tell us your enquiry"
                  {...fromLinkInputs(this, "comments")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: "Request A Service Form - Entered \"ENQUIRY\""
                    })
                  }}
                />
              </FormGroup>

              {
                serviceCode &&
                serviceOptions &&
                  <FormGroup>
                    <ServiceSummary
                      serviceType={this.serviceType}
                      serviceData={serviceOptions && serviceOptions.serviceItems}
                      serviceCode={serviceCode}
                      vinRego={vinRego}
                      asmc={asmc}
                      isChangeItemsDisable={isChangeItemsEnabled === 'false'}
                      serviceSummaryDescription={serviceSummaryDescription} />
                  </FormGroup>
              }
              <Space />
              <FormGroup show checkbox>
                <InputCheckBox
                  name="privacy"
                  label={
                    <span>
                      {privacyPolicy}{" "}
                      <A
                        href={privacyPolicyLink}
                        onClick={()=>{
                          gtmHandler({
                            pageCategory: "Request A Service Form",
                            pageAction: "Request A Service Form - Clicked \"PRIVACYPOLICY\""
                          })
                        }}
                        external>
                          <nobr>Privacy Policy</nobr>
                      </A>
                    </span>
                  }
                  {...fromLinkInputs(this, "privacy", () => {
                    gtmHandler({
                      pageCategory: "Request A Service Form",
                      pageAction: "Request A Service Form - Checked \"PRIVACYPOLICY\""
                    })
                  })}
                />
              </FormGroup>
              <Space />
              <Space />
              <FormGroup>
                {errorMessage &&
                  <AlertList data={errorMessage} />
                }
                <Button
                  styleName="black"
                  loading={loading}
                  fullWidth
                  {...formLinkSubmit(this, this._handleSubmit)}
                >
                  {buttonText}
                </Button>
              </FormGroup>

            </form>
          </div>
        </div>
      </Section>
    )
  }
}


export default BookServiceForm



// WEBPACK FOOTER //
// ./src/AtomicContainers/BookServiceForm/BookServiceForm.jsx